import React, { useEffect } from "react";
import { Resource } from "react-admin";
import UserIcon from "@material-ui/icons/AccountBox";

// Maschera migrata su Polar (Strangler Fig): la lista react-admin è sostituita
// da un semplice redirect a pagina intera. Nessun codice condiviso con l'app
// Polar — l'unico punto di contatto è questo window.location.
const RedirectToPolar = () => {
    useEffect(() => {
        window.location.href = "/polar/profile";
    }, []);
    return <div style={{ padding: 24 }}>Reindirizzamento…</div>;
};

export default permissions => (
    <Resource name="profile" icon={UserIcon} list={RedirectToPolar} />
);



// WEBPACK FOOTER //
// ./src/resources/Profile/index.js